import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './ViewLeads.css';
import { FaEye, FaTrash, FaSearch } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { showError, showSuccess, showWarning } from '../utils/sweetAlertHelper';

function ViewLeads() {
  const [leads, setLeads] = useState([]);
  const [users, setUsers] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editLeadId, setEditLeadId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  
  // Filter states
  const [leadTempFilter, setLeadTempFilter] = useState('');
  const [assignedToFilter, setAssignedToFilter] = useState('');
  const [leadTypeFilter, setLeadTypeFilter] = useState('');
  const [sourceFilter, setSourceFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [phoneFilter, setPhoneFilter] = useState('');
  const [isManualCountry, setIsManualCountry] = useState(false);
  const [manualCountryValue, setManualCountryValue] = useState('');

  // ✅ NEW: Scan Business Card State
  const [isScanning, setIsScanning] = useState(false);

  // Searchable dropdown states
  const [countrySearch, setCountrySearch] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [form, setForm] = useState({
    company: '',
    name: '',
    designation: '',
    telegram: '',
    linkedin: '',
    email: '',
    phone: '',
    countryCode: '', // Empty by default - user must select
    country: '',
    website: '',
    status: 'new',
    type: 'initial_1',
    source: '',
    assignedTo: '',
    leadsType: '',
    leadTemperature: 'cold',
    nextFollowupAt: '',
    followupNote: '',
    comment: '', // Added comment field
    comments: [],
    followups: []
  });

  const [errors, setErrors] = useState({});

  // Country codes with flags - Complete list from first version
  const countryCodes = [
    { code: '+93', country: 'Afghanistan', flag: '🇦🇫' },
    { code: '+355', country: 'Albania', flag: '🇦🇱' },
    { code: '+213', country: 'Algeria', flag: '🇩🇿' },
    { code: '+1684', country: 'American Samoa', flag: '🇦🇸' },
    { code: '+376', country: 'Andorra', flag: '🇦🇩' },
    { code: '+244', country: 'Angola', flag: '🇦🇴' },
    { code: '+1264', country: 'Anguilla', flag: '🇦🇮' },
    { code: '+672', country: 'Antarctica', flag: '🇦🇶' },
    { code: '+1268', country: 'Antigua and Barbuda', flag: '🇦🇬' },
    { code: '+54', country: 'Argentina', flag: '🇦🇷' },
    { code: '+374', country: 'Armenia', flag: '🇦🇲' },
    { code: '+297', country: 'Aruba', flag: '🇦🇼' },
    { code: '+61', country: 'Australia', flag: '🇦🇺' },
    { code: '+43', country: 'Austria', flag: '🇦🇹' },
    { code: '+994', country: 'Azerbaijan', flag: '🇦🇿' },
    { code: '+1242', country: 'Bahamas', flag: '🇧🇸' },
    { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
    { code: '+880', country: 'Bangladesh', flag: '🇧🇩' },
    { code: '+1246', country: 'Barbados', flag: '🇧🇧' },
    { code: '+375', country: 'Belarus', flag: '🇧🇾' },
    { code: '+32', country: 'Belgium', flag: '🇧🇪' },
    { code: '+501', country: 'Belize', flag: '🇧🇿' },
    { code: '+229', country: 'Benin', flag: '🇧🇯' },
    { code: '+1441', country: 'Bermuda', flag: '🇧🇲' },
    { code: '+975', country: 'Bhutan', flag: '🇧🇹' },
    { code: '+591', country: 'Bolivia', flag: '🇧🇴' },
    { code: '+387', country: 'Bosnia and Herzegovina', flag: '🇧🇦' },
    { code: '+267', country: 'Botswana', flag: '🇧🇼' },
    { code: '+55', country: 'Brazil', flag: '🇧🇷' },
    { code: '+673', country: 'Brunei', flag: '🇧🇳' },
    { code: '+359', country: 'Bulgaria', flag: '🇧🇬' },
    { code: '+226', country: 'Burkina Faso', flag: '🇧🇫' },
    { code: '+257', country: 'Burundi', flag: '🇧🇮' },
    { code: '+855', country: 'Cambodia', flag: '🇰🇭' },
    { code: '+237', country: 'Cameroon', flag: '🇨🇲' },
    { code: '+1', country: 'Canada/USA', flag: '🇺🇸' },
    { code: '+238', country: 'Cape Verde', flag: '🇨🇻' },
    { code: '+1345', country: 'Cayman Islands', flag: '🇰🇾' },
    { code: '+236', country: 'Central African Republic', flag: '🇨🇫' },
    { code: '+235', country: 'Chad', flag: '🇹🇩' },
    { code: '+56', country: 'Chile', flag: '🇨🇱' },
    { code: '+86', country: 'China', flag: '🇨🇳' },
    { code: '+57', country: 'Colombia', flag: '🇨🇴' },
    { code: '+269', country: 'Comoros', flag: '🇰🇲' },
    { code: '+242', country: 'Congo', flag: '🇨🇬' },
    { code: '+243', country: 'DR Congo', flag: '🇨🇩' },
    { code: '+682', country: 'Cook Islands', flag: '🇨🇰' },
    { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
    { code: '+385', country: 'Croatia', flag: '🇭🇷' },
    { code: '+53', country: 'Cuba', flag: '🇨🇺' },
    { code: '+357', country: 'Cyprus', flag: '🇨🇾' },
    { code: '+420', country: 'Czech Republic', flag: '🇨🇿' },
    { code: '+45', country: 'Denmark', flag: '🇩🇰' },
    { code: '+253', country: 'Djibouti', flag: '🇩🇯' },
    { code: '+1767', country: 'Dominica', flag: '🇩🇲' },
    { code: '+1809', country: 'Dominican Republic', flag: '🇩🇴' },
    { code: '+593', country: 'Ecuador', flag: '🇪🇨' },
    { code: '+20', country: 'Egypt', flag: '🇪🇬' },
    { code: '+503', country: 'El Salvador', flag: '🇸🇻' },
    { code: '+240', country: 'Equatorial Guinea', flag: '🇬🇶' },
    { code: '+291', country: 'Eritrea', flag: '🇪🇷' },
    { code: '+372', country: 'Estonia', flag: '🇪🇪' },
    { code: '+251', country: 'Ethiopia', flag: '🇪🇹' },
    { code: '+679', country: 'Fiji', flag: '🇫🇯' },
    { code: '+358', country: 'Finland', flag: '🇫🇮' },
    { code: '+33', country: 'France', flag: '🇫🇷' },
    { code: '+220', country: 'Gambia', flag: '🇬🇲' },
    { code: '+995', country: 'Georgia', flag: '🇬🇪' },
    { code: '+49', country: 'Germany', flag: '🇩🇪' },
    { code: '+233', country: 'Ghana', flag: '🇬🇭' },
    { code: '+30', country: 'Greece', flag: '🇬🇷' },
    { code: '+299', country: 'Greenland', flag: '🇬🇱' },
    { code: '+1473', country: 'Grenada', flag: '🇬🇩' },
    { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
    { code: '+224', country: 'Guinea', flag: '🇬🇳' },
    { code: '+245', country: 'Guinea-Bissau', flag: '🇬🇼' },
    { code: '+592', country: 'Guyana', flag: '🇬🇾' },
    { code: '+509', country: 'Haiti', flag: '🇭🇹' },
    { code: '+504', country: 'Honduras', flag: '🇭🇳' },
    { code: '+852', country: 'Hong Kong', flag: '🇭🇰' },
    { code: '+36', country: 'Hungary', flag: '🇭🇺' },
    { code: '+354', country: 'Iceland', flag: '🇮🇸' },
    { code: '+91', country: 'India', flag: '🇮🇳' },
    { code: '+62', country: 'Indonesia', flag: '🇮🇩' },
    { code: '+98', country: 'Iran', flag: '🇮🇷' },
    { code: '+964', country: 'Iraq', flag: '🇮🇶' },
    { code: '+353', country: 'Ireland', flag: '🇮🇪' },
    { code: '+972', country: 'Israel', flag: '🇮🇱' },
    { code: '+39', country: 'Italy', flag: '🇮🇹' },
    { code: '+81', country: 'Japan', flag: '🇯🇵' },
    { code: '+962', country: 'Jordan', flag: '🇯🇴' },
    { code: '+7', country: 'Kazakhstan/Russia', flag: '🇰🇿' },
    { code: '+254', country: 'Kenya', flag: '🇰🇪' },
    { code: '+686', country: 'Kiribati', flag: '🇰🇮' },
    { code: '+965', country: 'Kuwait', flag: '🇰🇼' },
    { code: '+996', country: 'Kyrgyzstan', flag: '🇰🇬' },
    { code: '+856', country: 'Laos', flag: '🇱🇦' },
    { code: '+371', country: 'Latvia', flag: '🇱🇻' },
    { code: '+961', country: 'Lebanon', flag: '🇱🇧' },
    { code: '+266', country: 'Lesotho', flag: '🇱🇸' },
    { code: '+231', country: 'Liberia', flag: '🇱🇷' },
    { code: '+218', country: 'Libya', flag: '🇱🇾' },
    { code: '+423', country: 'Liechtenstein', flag: '🇱🇮' },
    { code: '+370', country: 'Lithuania', flag: '🇱🇹' },
    { code: '+352', country: 'Luxembourg', flag: '🇱🇺' },
    { code: '+853', country: 'Macau', flag: '🇲🇴' },
    { code: '+389', country: 'North Macedonia', flag: '🇲🇰' },
    { code: '+261', country: 'Madagascar', flag: '🇲🇬' },
    { code: '+265', country: 'Malawi', flag: '🇲🇼' },
    { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
    { code: '+960', country: 'Maldives', flag: '🇲🇻' },
    { code: '+223', country: 'Mali', flag: '🇲🇱' },
    { code: '+356', country: 'Malta', flag: '🇲🇹' },
    { code: '+692', country: 'Marshall Islands', flag: '🇲🇭' },
    { code: '+222', country: 'Mauritania', flag: '🇲🇷' },
    { code: '+230', country: 'Mauritius', flag: '🇲🇺' },
    { code: '+52', country: 'Mexico', flag: '🇲🇽' },
    { code: '+691', country: 'Micronesia', flag: '🇫🇲' },
    { code: '+373', country: 'Moldova', flag: '🇲🇩' },
    { code: '+377', country: 'Monaco', flag: '🇲🇨' },
    { code: '+976', country: 'Mongolia', flag: '🇲🇳' },
    { code: '+382', country: 'Montenegro', flag: '🇲🇪' },
    { code: '+212', country: 'Morocco', flag: '🇲🇦' },
    { code: '+258', country: 'Mozambique', flag: '🇲🇿' },
    { code: '+95', country: 'Myanmar', flag: '🇲🇲' },
    { code: '+264', country: 'Namibia', flag: '🇳🇦' },
    { code: '+674', country: 'Nauru', flag: '🇳🇷' },
    { code: '+977', country: 'Nepal', flag: '🇳🇵' },
    { code: '+31', country: 'Netherlands', flag: '🇳🇱' },
    { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
    { code: '+505', country: 'Nicaragua', flag: '🇳🇮' },
    { code: '+227', country: 'Niger', flag: '🇳🇪' },
    { code: '+234', country: 'Nigeria', flag: '🇳🇬' },
    { code: '+850', country: 'North Korea', flag: '🇰🇵' },
    { code: '+47', country: 'Norway', flag: '🇳🇴' },
    { code: '+968', country: 'Oman', flag: '🇴🇲' },
    { code: '+92', country: 'Pakistan', flag: '🇵🇰' },
    { code: '+680', country: 'Palau', flag: '🇵🇼' },
    { code: '+970', country: 'Palestine', flag: '🇵🇸' },
    { code: '+507', country: 'Panama', flag: '🇵🇦' },
    { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬' },
    { code: '+595', country: 'Paraguay', flag: '🇵🇾' },
    { code: '+51', country: 'Peru', flag: '🇵🇪' },
    { code: '+63', country: 'Philippines', flag: '🇵🇭' },
    { code: '+48', country: 'Poland', flag: '🇵🇱' },
    { code: '+351', country: 'Portugal', flag: '🇵🇹' },
    { code: '+974', country: 'Qatar', flag: '🇶🇦' },
    { code: '+40', country: 'Romania', flag: '🇷🇴' },
    { code: '+7', country: 'Russia', flag: '🇷🇺' },
    { code: '+250', country: 'Rwanda', flag: '🇷🇼' },
    { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
    { code: '+221', country: 'Senegal', flag: '🇸🇳' },
    { code: '+381', country: 'Serbia', flag: '🇷🇸' },
    { code: '+248', country: 'Seychelles', flag: '🇸🇨' },
    { code: '+232', country: 'Sierra Leone', flag: '🇸🇱' },
    { code: '+65', country: 'Singapore', flag: '🇸🇬' },
    { code: '+421', country: 'Slovakia', flag: '🇸🇰' },
    { code: '+386', country: 'Slovenia', flag: '🇸🇮' },
    { code: '+677', country: 'Solomon Islands', flag: '🇸🇧' },
    { code: '+252', country: 'Somalia', flag: '🇸🇴' },
    { code: '+27', country: 'South Africa', flag: '🇿🇦' },
    { code: '+82', country: 'South Korea', flag: '🇰🇷' },
    { code: '+211', country: 'South Sudan', flag: '🇸🇸' },
    { code: '+34', country: 'Spain', flag: '🇪🇸' },
    { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' },
    { code: '+249', country: 'Sudan', flag: '🇸🇩' },
    { code: '+597', country: 'Suriname', flag: '🇸🇷' },
    { code: '+46', country: 'Sweden', flag: '🇸🇪' },
    { code: '+41', country: 'Switzerland', flag: '🇨🇭' },
    { code: '+963', country: 'Syria', flag: '🇸🇾' },
    { code: '+886', country: 'Taiwan', flag: '🇹🇼' },
    { code: '+992', country: 'Tajikistan', flag: '🇹🇯' },
    { code: '+255', country: 'Tanzania', flag: '🇹🇿' },
    { code: '+66', country: 'Thailand', flag: '🇹🇭' },
    { code: '+228', country: 'Togo', flag: '🇹🇬' },
    { code: '+676', country: 'Tonga', flag: '🇹🇴' },
    { code: '+216', country: 'Tunisia', flag: '🇹🇳' },
    { code: '+90', country: 'Turkey', flag: '🇹🇷' },
    { code: '+993', country: 'Turkmenistan', flag: '🇹🇲' },
    { code: '+256', country: 'Uganda', flag: '🇺🇬' },
    { code: '+380', country: 'Ukraine', flag: '🇺🇦' },
    { code: '+971', country: 'UAE', flag: '🇦🇪' },
    { code: '+44', country: 'UK', flag: '🇬🇧' },
    { code: '+1', country: 'USA', flag: '🇺🇸' },
    { code: '+598', country: 'Uruguay', flag: '🇺🇾' },
    { code: '+998', country: 'Uzbekistan', flag: '🇺🇿' },
    { code: '+678', country: 'Vanuatu', flag: '🇻🇺' },
    { code: '+58', country: 'Venezuela', flag: '🇻🇪' },
    { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
    { code: '+967', country: 'Yemen', flag: '🇾🇪' },
    { code: '+260', country: 'Zambia', flag: '🇿🇲' },
    { code: '+263', country: 'Zimbabwe', flag: '🇿🇼' },
  ];

  // Click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const formatToLocalDateTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    const tzOffset = date.getTimezoneOffset() * 60000;
    return new Date(date - tzOffset).toISOString().slice(0, 16);
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Company is mandatory
    if (!form.company || form.company.trim() === '') {
      newErrors.company = 'Company name is required';
    }
    
    // Email validation
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    // Phone validation (only digits, 7-15 digits from first version)
    if (form.phone && !/^\d{7,15}$/.test(form.phone)) {
      newErrors.phone = 'Phone number must be 7 to 15 digits';
    }
    
    // LinkedIn URL validation
    if (form.linkedin && !/^(https?:\/\/)?(www\.)?linkedin\.com\/.+/.test(form.linkedin)) {
      newErrors.linkedin = 'Please enter a valid LinkedIn URL';
    }
    
    // Website URL validation
    if (form.website && !/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?\/?$/.test(form.website)) {
      newErrors.website = 'Please enter a valid website URL';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchLeads = async () => {
    const token = localStorage.getItem('token');
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/leads/list`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  };

  const fetchUsers = async () => {
    const token = localStorage.getItem('token');
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/leads/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setUsers(res.data);
  };

  useEffect(() => {
    const getLeads = async () => {
      const leadsData = await fetchLeads();
      setLeads(leadsData);
    };
    
    getLeads();
    
    if (user?.role === 'admin' || user?.role === 'vendor') {
      fetchUsers();
    }
  }, [user?.role]);

  const handleSave = async () => {
    if (!validateForm()) {
      showWarning('Please fix the validation errors before saving.');
      return;
    }

    const token = localStorage.getItem('token');
    const formToSend = {
      ...form,
      phone: form.countryCode + form.phone
    };
    delete formToSend.comments;
    delete formToSend.followups;
    delete formToSend.countryCode;
    delete formToSend.comment; // Remove comment field before sending to API

    if (formToSend.assignedTo === '') {
      delete formToSend.assignedTo;
    }

    if (!formToSend.nextFollowupAt) {
      delete formToSend.nextFollowupAt;
    }

    if (!formToSend.followupNote) {
      delete formToSend.followupNote;
    }

    try {
      if (isEditMode) {
        await axios.put(`${process.env.REACT_APP_API_URL}/leads/${editLeadId}`, formToSend, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // Add comment if provided
        if (form.comment && form.comment.trim()) {
          await axios.post(`${process.env.REACT_APP_API_URL}/leads/${editLeadId}/comment`, {
            text: form.comment
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/leads/add`, formToSend, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      setShowModal(false);
      setEditLeadId(null);
      setIsEditMode(false);
      resetForm();
      
      // Refresh the leads list after saving
      const leadsData = await fetchLeads();
      setLeads(leadsData);
      showSuccess(isEditMode ? 'Lead updated successfully!' : 'Lead added successfully!');
    } catch (err) {
      console.error('Save Lead Error:', err.response?.data || err.message);
      showError('Error saving lead: ' + (err.response?.data?.message || err.message));
    }
  };

  const resetForm = () => {
    setForm({
      company: '',
      name: '',
      designation: '',
      telegram: '',
      linkedin: '',
      email: '',
      phone: '',
      countryCode: '',
      country: '',
      website: '',
      status: 'new',
      type: 'initial_1',
      source: '',
      assignedTo: '',
      leadsType: '',
      leadTemperature: 'cold',
      nextFollowupAt: '',
      followupNote: '',
      comment: '', // Added comment field
      comments: [],
      followups: []
    });
    setErrors({});
    setCountrySearch('');
    setIsDropdownOpen(false);
  };

  const handleCountryCodeSelect = (code) => {
    // Find the country name for the selected code
    const selectedCountry = countryCodes.find(c => c.code === code);
    const countryName = selectedCountry ? selectedCountry.country : '';
    
    setForm({ 
      ...form, 
      countryCode: code,
      country: countryName
    });
    setIsDropdownOpen(false);
    setCountrySearch('');
    setIsManualCountry(false);
    setManualCountryValue('');
  };

  const handleManualCountryChange = (e) => {
    const value = e.target.value;
    setManualCountryValue(value);
    
    // Find country name for the manually entered code
    const selectedCountry = countryCodes.find(c => c.code === value);
    const countryName = selectedCountry ? selectedCountry.country : '';
    
    setForm({ 
      ...form, 
      countryCode: value,
      country: countryName
    });
  };

  // Filter countries based on search
  const filteredCountries = countryCodes.filter(country => 
    country.country.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.code.includes(countrySearch)
  );

  const handleEditClick = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leads/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const lead = res.data;
      
      // Extract country code and phone number from stored phone
      let countryCode = '';
      let phone = lead.phone || '';
      
      // Try to extract country code
      const foundCode = countryCodes.find(c => phone.startsWith(c.code));
      if (foundCode) {
        countryCode = foundCode.code;
        phone = phone.replace(foundCode.code, '');
      }

      setForm({
        ...lead,
        name: lead.name || '',
        designation: lead.designation || '',
        telegram: lead.telegram || '',
        phone: phone,
        countryCode: countryCode,
        assignedTo: lead.assignedTo?._id || '',
        comment: '',
        comments: lead.comments || [],
        followups: lead.followups || [],
        nextFollowupAt: lead.nextFollowupAt ? formatToLocalDateTime(lead.nextFollowupAt) : '',
        followupNote: '',
        leadTemperature: lead.leadTemperature || 'cold'
      });

      setEditLeadId(id);
      setIsEditMode(true);
      setShowModal(true);
      setErrors({});
      setCountrySearch('');
      setIsDropdownOpen(false);
    } catch (error) {
      console.error('Error fetching lead details:', error);
      showError('Failed to load lead details. Please try again.');
    }
  };

  const handleBulkUpload = async () => {
    if (!bulkFile) {
      showWarning('Please select an Excel file first.');
      return;
    }

    const formData = new FormData();
    formData.append('file', bulkFile);

    const token = localStorage.getItem('token');
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/leads/import`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      showSuccess(res.data.message + ` (${res.data.count} leads uploaded)`);
      setBulkFile(null);
      
      // Refresh the leads list after bulk upload
      const leadsData = await fetchLeads();
      setLeads(leadsData);
    } catch (err) {
      console.error("Bulk Upload Error:", err.response?.data || err.message);
      showError('Bulk Upload Failed: ' + (err.response?.data?.message || err.message));
    }
  };

  const handleDeleteLead = async (id) => {
    if (!window.confirm("Are you sure you want to delete this lead?")) return;

    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/leads/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showSuccess('Lead soft deleted successfully');
      
      // Refresh the leads list after deletion
      const leadsData = await fetchLeads();
      setLeads(leadsData);
    } catch (err) {
      console.error('Delete Error:', err.response?.data || err.message);
      showError('Error deleting lead: ' + (err.response?.data?.message || err.message));
    }
  };

  const downloadFilteredLeads = () => {
    const exportData = filteredLeads.map(lead => ({
      Company: lead.company,
      Name: lead.name || '',
      Designation: lead.designation || '',
      Telegram: lead.telegram || '',
      LinkedIn: lead.linkedin || '',
      Email: lead.email,
      Phone: lead.phone,
      Country: lead.country,
      LeadTemperature: lead.leadTemperature || 'cold',
      Status: lead.status,
      Type: lead.type,
      Source: lead.source || '-',
      LeadsType: lead.leadsType || '-',
      AssignedTo: lead.assignedTo?.email || 'Unassigned',
      CreatedAt: new Date(lead.createdAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'Leads.xlsx');
  };

  const resetFilters = () => {
    setSearch('');
    setFromDate('');
    setToDate('');
    setLeadTempFilter('');
    setAssignedToFilter('');
    setLeadTypeFilter('');
    setSourceFilter('');
    setStatusFilter('');
    setPhoneFilter('');
    setCurrentPage(1);
  };

  // Filter leads based on all filters
  const filteredLeads = leads
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .filter(lead => {
      const q = search.toLowerCase();
      const createdAt = new Date(lead.createdAt);

      const matchesSearch =
        lead.company.toLowerCase().includes(q) ||
        lead.email.toLowerCase().includes(q) ||
        lead.leadsType?.toLowerCase().includes(q) ||
        (lead.leadTemperature || '').toLowerCase().includes(q) ||
        (lead.status || '').toLowerCase().includes(q) || 
        (lead.assignedTo ? lead.assignedTo.email.toLowerCase().includes(q) : 'unassigned'.includes(q));

      const matchesDate =
        (!fromDate || createdAt >= new Date(fromDate)) &&
        (!toDate || createdAt <= new Date(toDate + 'T23:59:59'));

      const matchesLeadTemp = 
        !leadTempFilter || (lead.leadTemperature || 'cold') === leadTempFilter;
      
      const matchesAssignedTo = 
        !assignedToFilter || 
        (assignedToFilter === 'unassigned' && !lead.assignedTo) ||
        (lead.assignedTo && lead.assignedTo._id === assignedToFilter);
      
      const matchesLeadType = 
        !leadTypeFilter || lead.leadsType === leadTypeFilter;
      
      const matchesSource = 
        !sourceFilter || lead.source === sourceFilter;
      
      const matchesStatus =
        !statusFilter || lead.status === statusFilter;
        
      // Phone filter - search in the last 10 digits (without country code)
      const matchesPhone =
        !phoneFilter || 
        (lead.phone && lead.phone.replace(/\D/g, '').slice(-10).includes(phoneFilter));

      return matchesSearch && matchesDate && matchesLeadTemp && matchesAssignedTo && 
             matchesLeadType && matchesSource && matchesStatus && matchesPhone;
    });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLeads = filteredLeads.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLeads.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const half = Math.floor(maxVisiblePages / 2);
      let start = Math.max(1, currentPage - half);
      const end = Math.min(totalPages, start + maxVisiblePages - 1);

      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }

      if (start > 1) {
        pageNumbers.push(1);
        if (start > 2) {
          pageNumbers.push('...');
        }
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (end < totalPages) {
        if (end < totalPages - 1) {
          pageNumbers.push('...');
        }
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers.map((number, index) => (
      number === '...' ? (
        <span key={index} className="ellipsis">...</span>
      ) : (
        <button
          key={index}
          onClick={() => paginate(number)}
          className={currentPage === number ? 'active' : ''}
        >
          {number}
        </button>
      )
    ));
  };

  // Format phone number input to only allow digits
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 15);
    setForm({ ...form, phone: value });
  };

  // Handle phone filter input
  const handlePhoneFilterChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 15);
    setPhoneFilter(value);
  };

  // ============================================
  // ✅ NEW: Handle Business Card Scan
  // ============================================
  const handleCardUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      showWarning('Please upload a valid image file');
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      showWarning('Image size should be less than 10MB');
      return;
    }

    setIsScanning(true);
    
    const formData = new FormData();
    formData.append('card', file);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/leads/scan-card`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      const scannedData = response.data;
      
      // Auto-fill the form with scanned data
      setForm(prev => ({
        ...prev,
        company: scannedData.company || prev.company,
        name: scannedData.name || prev.name,
        designation: scannedData.designation || prev.designation,
        email: scannedData.email || prev.email,
        phone: scannedData.phone || prev.phone,
        countryCode: scannedData.countryCode || prev.countryCode,
        country: scannedData.country || prev.country,
        website: scannedData.website || prev.website,
        telegram: scannedData.telegram || prev.telegram,
        linkedin: scannedData.linkedin || prev.linkedin
      }));

      showSuccess('Business card scanned successfully!');

    } catch (error) {
      console.error('Scan Error:', error);
      showError('Failed to scan business card: ' + (error.response?.data?.message || error.message));
    } finally {
      setIsScanning(false);
      // Clear the input
      e.target.value = null;
    }
  };

  return (
    <div className="lead-container">
      <div className="action-buttons">
        <button className="add-button" onClick={() => {
          setShowModal(true);
          setIsEditMode(false);
          setEditLeadId(null);
          resetForm();
        }}>Add Lead</button>

        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={(e) => setBulkFile(e.target.files[0])}
          style={{ marginLeft: '10px' }}
        />

        <button className="bulk-upload-button" onClick={handleBulkUpload}>Bulk Upload</button>
        <button className="export-button" onClick={downloadFilteredLeads}>Export Filtered Leads</button>
        <button className="reset-button" onClick={resetFilters}>Reset Filters</button>
      </div>

      {/* Search and Filters */}
      <div className="filters-container">
        <div className="search-filter">
          <input
            type="text"
            placeholder="Search Company, Email or Assigned Email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        
        <div className="date-filters">
          <div className="date-filter">
            <label>From:</label>
            <input
              type="date"
              onChange={(e) => setFromDate(e.target.value)}
              value={fromDate}
            />
          </div>
          <div className="date-filter">
            <label>To:</label>
            <input
              type="date"
              onChange={(e) => setToDate(e.target.value)}
              value={toDate}
            />
          </div>
        </div>
        
        <div className="dropdown-filters">
          <div className="filter-group">
            <label>Lead Temp:</label>
            <select 
              value={leadTempFilter} 
              onChange={(e) => setLeadTempFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="hot">Hot</option>
              <option value="cold">Cold</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label>Status:</label>
            <select 
              value={statusFilter} 
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="new">New</option>
              <option value="contacted">Contacted</option>
              <option value="Converted">Converted</option>
              <option value="disqualified">Disqualified</option>
              <option value="inprocess">In Process</option>
              <option value="demo-scheduled">Demo Scheduled</option>
              <option value="proposal-shared">Proposal Shared</option>
            </select>
          </div>
          
          {user?.role === 'admin' && (
            <div className="filter-group">
              <label>Assigned To:</label>
              <select 
                value={assignedToFilter} 
                onChange={(e) => setAssignedToFilter(e.target.value)}
              >
                <option value="">All</option>
                <option value="unassigned">Unassigned</option>
                {users.map(u => (
                  <option key={u._id} value={u._id}>{u.name}</option>
                ))}
              </select>
            </div>
          )}
          
          <div className="filter-group">
            <label>Lead Type:</label>
            <select 
              value={leadTypeFilter} 
              onChange={(e) => setLeadTypeFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="It">IT</option>
              <option value="b2b">B2B</option>
              <option value="affiliate">Affiliate</option>
              <option value="ecommerce">Ecommerce</option>
              <option value="other">Other</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label>Source:</label>
            <select 
              value={sourceFilter} 
              onChange={(e) => setSourceFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="Whatsapp">Whatsapp</option>
              <option value="Linkedin">Linkedin</option>
              <option value="Instagram">Instagram</option>
              <option value="Telegram">Telegram</option>
              <option value="Igblive">Igblive</option>
              <option value="Meet-Alfred">Meet-Alfred</option>
              <option value="chatgpt">chatgpt</option>
              <option value="fair">fair</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label>Phone :</label>
            <input
              type="text"
              placeholder="Filter by phone"
              value={phoneFilter}
              onChange={handlePhoneFilterChange}
              maxLength="15"
            />
          </div>
        </div>
      </div>

      {/* Modal for Add/Edit Lead */}
      {showModal && (
        <div className="modal full-page-modal">
          <div className="modal-close" onClick={() => setShowModal(false)}>×</div>
          <div className="modal-content">
            <h2>{isEditMode ? 'Edit Lead' : 'Add New Lead'}</h2>
            
            {/* ✅ NEW: Scan Business Card Button */}
            <div className="scan-card-container">
              <button 
                className="scan-card-button"
                onClick={() => document.getElementById('cardInput').click()}
                disabled={isScanning}
              >
                📷 {isScanning ? 'Scanning...' : 'Scan Business Card'}
              </button>
              <input
                id="cardInput"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleCardUpload}
              />
              {isScanning && <span className="scanning-text">Processing...</span>}
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Company Name <span className="required-asterisk">*</span></label>
                <input 
                  value={form.company} 
                  onChange={e => setForm({ ...form, company: e.target.value })} 
                  className={errors.company ? 'error' : ''}
                />
                {errors.company && <span className="error-text">{errors.company}</span>}
              </div>
              <div className="form-group">
                <label>Contact Person Name</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
              </div>
            </div>
            
            <div className="form-group">
              <label>Designation</label>
              <input value={form.designation} onChange={e => setForm({ ...form, designation: e.target.value })} />
            </div>
            
            <div className="form-group">
              <label>Telegram</label>
              <input value={form.telegram} onChange={e => setForm({ ...form, telegram: e.target.value })} />
            </div>
            
            <div className="form-group">
              <label>LinkedIn</label>
              <input 
                value={form.linkedin} 
                onChange={e => setForm({ ...form, linkedin: e.target.value })} 
                placeholder="https://linkedin.com/..."
                className={errors.linkedin ? 'error' : ''}
              />
              {errors.linkedin && <span className="error-text">{errors.linkedin}</span>}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email</label>
                <input 
                  value={form.email} 
                  onChange={e => setForm({ ...form, email: e.target.value })} 
                  type="email"
                  className={errors.email ? 'error' : ''}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>
              <div className="form-group phone-input-group">
                <label>Phone</label>
                <div className="phone-input-container">
                  {!isManualCountry ? (
                    <>
                      <div className="country-select-wrapper" ref={dropdownRef}>
                        <div 
                          className="country-select-header"
                          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                          <span>
                            {(() => {
                              const selected = countryCodes.find(c => c.code === form.countryCode);
                              return selected ? `${selected.flag} ${selected.code}` : '+91';
                            })()}
                          </span>
                          <span className="dropdown-arrow">▼</span>
                        </div>
                        {isDropdownOpen && (
                          <div className="country-dropdown-list">
                            <div className="country-search-box">
                              <FaSearch className="search-icon" />
                              <input
                                type="text"
                                placeholder="Search country or code..."
                                value={countrySearch}
                                onChange={(e) => setCountrySearch(e.target.value)}
                                autoFocus
                              />
                            </div>
                            <div className="country-options">
                              {filteredCountries.length > 0 ? (
                                filteredCountries.map((country, index) => (
                                  <div
                                    key={index}
                                    className={`country-option ${country.code === form.countryCode ? 'selected' : ''}`}
                                    onClick={() => handleCountryCodeSelect(country.code)}
                                  >
                                    <span className="country-flag" style={{ marginRight: 6 }}>{country.flag}</span>
                                    <span className="country-code" style={{ marginRight: 8 }}>{country.code}</span>
                                    <span className="country-name">{country.country}</span>
                                  </div>
                                ))
                              ) : (
                                <div className="no-results-found">No results found</div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <button 
                        type="button"
                        onClick={() => setIsManualCountry(true)}
                        className="manual-code-btn"
                        title="Enter country code manually"
                      >
                        enter code manually
                      </button>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="Enter code (+___ )"
                        value={manualCountryValue}
                        onChange={handleManualCountryChange}
                        className="country-code-manual-input"
                      />
                      <button 
                        type="button"
                        onClick={() => {
                          setIsManualCountry(false);
                          setManualCountryValue('');
                          setForm({ ...form, countryCode: '', country: '' });
                          setCountrySearch('');
                        }}
                        className="auto-code-btn"
                      >
                        select from list
                      </button>
                    </>
                  )}
                  <input 
                    value={form.phone} 
                    onChange={handlePhoneChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength="15"
                    placeholder="15 digits only"
                    className={errors.phone ? 'error' : ''}
                  />
                </div>
                {errors.phone && <span className="error-text">{errors.phone}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Country</label>
                <input value={form.country} onChange={e => setForm({ ...form, country: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Website URL</label>
                <input 
                  value={form.website} 
                  onChange={e => setForm({ ...form, website: e.target.value })} 
                  placeholder="https://example.com"
                  className={errors.website ? 'error' : ''}
                />
                {errors.website && <span className="error-text">{errors.website}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group checkbox-group">
                <input
                  type="checkbox"
                  checked={form.leadTemperature === 'hot'}
                  onChange={(e) => setForm({ ...form, leadTemperature: e.target.checked ? 'hot' : 'cold' })}
                  id="hotLead"
                />
                <label htmlFor="hotLead">Hot Lead</label>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Status</label>
                <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="Converted">Converted</option>
                  <option value="disqualified">Disqualified</option>
                  <option value="qualified">Qualified</option>
                  <option value="inprocess">In Process</option>
                  <option value="demo-scheduled">Demo Scheduled</option>
                  <option value="proposal-shared">Proposal Shared</option>
                </select>
              </div>
              <div className="form-group">
                <label>Type</label>
                <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                  <option value="initial_1">Initial 1</option>
                  <option value="followup_1">Followup 1</option>
                  <option value="followup_2">Followup 2</option>
                  <option value="followup_3">Followup 3</option>
                  <option value="closure">Closure</option>
                  <option value="closed-converted">Closed - Converted</option>
                  <option value="closed-lost">Closed - Lost</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Source</label>
                <select value={form.source} onChange={e => setForm({ ...form, source: e.target.value })}>
                  <option value="">Select Source</option>
                  <option value="Whatsapp">Whatsapp</option>
                  <option value="Linkedin">Linkedin</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Telegram">Telegram</option>
                  <option value="Igblive">Igblive</option>
                  <option value="Meet-Alfred">Meet-Alfred</option>
                  <option value="chatgpt">chatgpt</option>
                  
                  <option value="event">event</option>
                  <option value="research">research</option>
                  <option value="other">other</option>
                </select>
              </div>
              <div className="form-group">
                <label>Lead Type</label>
                <select value={form.leadsType} onChange={e => setForm({ ...form, leadsType: e.target.value })}>
                  <option value="">Select Lead Type</option>
                  <option value="It">IT</option>
                  <option value="b2b">B2B</option>
                  <option value="affiliate">Affiliate</option>
                  <option value="ecommerce">Ecommerce</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            {(user?.role === 'admin' || user?.role === 'vendor') && (
              <div className="form-row">
                <div className="form-group">
                  <label>Assign To</label>
                  <select value={form.assignedTo} onChange={e => setForm({ ...form, assignedTo: e.target.value })}>
                    <option value="">Unassigned</option>
                    {users.map(u => (
                      <option key={u._id} value={u._id}>{u.name} ({u.email})</option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label>Next Follow-up</label>
                <input
                  type="datetime-local"
                  value={form.nextFollowupAt}
                  onChange={e => setForm({ ...form, nextFollowupAt: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Follow-up Note</label>
                <textarea
                  value={form.followupNote}
                  onChange={e => setForm({ ...form, followupNote: e.target.value })}
                  placeholder="Enter follow-up note"
                />
              </div>
            </div>

            {isEditMode && (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <label>Add Comment</label>
                    <textarea
                      value={form.comment || ''}
                      onChange={e => setForm({ ...form, comment: e.target.value })}
                      placeholder="Add a comment..."
                    ></textarea>
                  </div>
                </div>

                {form.comments && form.comments.length > 0 && (
                  <div className="comments-section">
                    <h4>Previous Comments:</h4>
                    <ul>
                      {form.comments.map((c, index) => (
                        <li key={index}>
                          <strong>{c.user?.name || 'Unknown'}:</strong> {c.text}
                          <br />
                          <small>{new Date(c.createdAt).toLocaleString()}</small>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {form.followups && form.followups.length > 0 && (
                  <div className="followup-history-section">
                    <h4>Follow-up History:</h4>
                    <ul>
                      {form.followups.map((f, index) => (
                        <li key={index}>
                          <strong>{new Date(f.date).toLocaleString()}</strong>
                          <br />
                          {f.note ? <span>{f.note}<br /></span> : null}
                          <small>
                            {f.done ? '✅ Done' : '⏳ Pending'} by {f.createdBy?.name || f.createdBy || 'Unknown'}
                          </small>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            )}

            <div className="modal-actions">
              <button className="save-button" onClick={handleSave}>{isEditMode ? 'Update' : 'Save'}</button>
              <button className="cancel-button" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Leads Table */}
      <div className="table-container">
        <table className="lead-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Country</th>
              <th>Lead Temp</th>
              <th>Status</th>
              <th>Type</th>
              <th>Source</th>
              <th>Lead Type</th>
              <th>Assigned To</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentLeads.length > 0 ? (
              currentLeads.map((lead, i) => (
                <tr key={i}>
                  <td>{lead.company}</td>
                  <td>{lead.name || '-'}</td>
                  <td>{lead.email}</td>
                  <td>{lead.phone}</td>
                  <td>{lead.country}</td>
                  <td className={`temp-${lead.leadTemperature || 'cold'}`}>
                    {lead.leadTemperature || 'cold'}
                  </td>
                  <td>{lead.status}</td>
                  <td>{lead.type}</td>
                  <td>{lead.source || '-'}</td>
                  <td>{lead.leadsType || '-'}</td>
                  <td>{lead.assignedTo?.email || 'Unassigned'}</td>
                  <td>
                    {new Date(lead.createdAt).toLocaleString('en-IN', {
                      dateStyle: 'medium',
                      timeStyle: 'short'
                    })}
                  </td>
                  <td className="actions">
                    <button className="view-button" onClick={() => handleEditClick(lead._id)}>
                      <FaEye />
                    </button>
                    {user?.role === 'admin' && (
                      <button className="delete-button" onClick={() => handleDeleteLead(lead._id)}>
                        <FaTrash />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="no-results">
                  No leads found matching your criteria
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {filteredLeads.length > itemsPerPage && (
          <div className="pagination-container">
            <div className="pagination-info">
              Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredLeads.length)} of {filteredLeads.length} leads
            </div>
            <div className="pagination-controls">
              <button
                onClick={() => paginate(1)}
                disabled={currentPage === 1}
                className="pagination-button"
              >
                First
              </button>
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-button"
              >
                Previous
              </button>
              
              {renderPageNumbers()}

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-button"
              >
                Next
              </button>
              <button
                onClick={() => paginate(totalPages)}
                disabled={currentPage === totalPages}
                className="pagination-button"
              >
                Last
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewLeads;